import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import DexAggregatorHero from "./DexAggregatorHero";
import WhatIsDEX from "./WhatIsDEX";
import DEXADev from "./DEXADev";
import FeaturesOfDEX from "./FeaturesOfDEX";
import CustomizableUIUX from "./CustomizableUIUX";
import CloneForDEX from "./CloneForDEX";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function DexAggregator() {
  return (
    <div>
      <Header />
      <DexAggregatorHero />
      <WhatIsDEX />
      <FeaturesOfDEX />
      <DEXADev />
      <CustomizableUIUX />
      <CloneForDEX />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default DexAggregator;
